<template>
  <div class="become-vip-message">
    <Message myWidth="444px" myHeight="250px" v-if="messageType == 1">
      <template v-slot:content>
        <div class="success-message-wrap">
          <div class="close" @click="closeClick()"></div>
          <!-- <div class="title"></div> -->
          <div class="content">
            <img
              class="successfully_opened"
              src="@/assets/becomevip/successfully_opened.png"
            />
            <p class="vip_expire_date">{{ vipDate }}</p>

            <!-- <div class="logo"></div>
						<div class="vip-time">有效期至：{{ vipDate }}</div>
						<div class="vip-rights-wrap">
							<div class="text-wrap">
								<div class="text1">小宝VIP</div>
								<div class="text2">特权尊享</div>
							</div>
						</div>
						<div class="vip-item-wrap">
							<div class="vip-item">
								<div class="icon1"></div>
								<div class="text">设备绑定不限</div>
							</div>
							<div class="vip-item">
								<div class="icon2"></div>
								<div class="text">访问次数不限</div>
							</div>
							<div class="vip-item">
								<div class="icon3"></div>
								<div class="text">相册备份</div>
							</div>
							<div class="vip-item">
								<div class="icon4"></div>
								<div class="text">远程开机</div>
							</div>
						</div> -->
          </div>
        </div>
      </template>
    </Message>
  </div>
</template>

<script>
import Message from "@/components/MessageTwo.vue";

export default {
  components: {
    Message,
  },
  props: {
    messageType: Number,
    vipDate: String,
  },
  data: function () {
    return {};
  },
  methods: {
    closeClick: function () {
      let _that = this;
      _that.$emit("closeMessageClick");
    },
  },
  mounted() {
    let _that = this;
  },
};
</script>

<style scoped lang="less">
.become-vip-message {
  .bg {
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .close {
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 10px;
    width: 14px;
    height: 14px;
    padding: 1px;
    .bg();
    background-image: url("../assets/common/close.png");
    cursor: pointer;
  }

  .success-message-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    .bg();
    background: linear-gradient(
      171deg,
      #ffd6b1 0%,
      #fff4ef 39.82%,
      #fff1ed 73.96%,
      #ffd7f9 100%
    );
    box-shadow: 1px 1px 2px 0px #fff inset;

    // background-image: url("../assets/becomevip/a.png");

    .title {
      position: relative;
      width: 100%;
      height: 73px;
    }
    .title::before,
    .title::after {
      content: "";
      top: 0;
      left: 0;
      width: 530px;
      height: 73px;
      position: absolute;
      background-color: #f3c8a3;
    }
    .title::after {
      .bg();
      background-image: url("../assets/becomevip/c.svg");
    }
    .content {
      height: 274px;
      width: 100%;
      .successfully_opened {
        margin-top: 33px;
      }
      .vip_expire_date {
        margin-top: 8px;
        font-size: 24px;
        font-weight: 700;
        background: var(
          --1,
          linear-gradient(179deg, #4b5147 43.46%, #232323 87.9%)
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .logo {
        display: inline-block;
        margin-top: 12px;
        width: 112px;
        height: 112px;
        .bg();
        background-image: url("../assets/becomevip/b.svg");
      }

      .vip-time {
        color: #999999;
      }
      .vip-rights-wrap {
        padding-left: 13px;
        padding-right: 13px;

        .text-wrap {
          margin-top: 14px;
          font-size: 15px;
          color: #92532e;
          text-align: center;
          font-weight: bold;
          .bg();
          background-image: url("../assets/becomevip/e.png");
          background-size: 100% 1px;
          div {
            display: inline-block;
          }
          .text2 {
            margin-left: 34px;
          }
          .text1 {
            position: relative;
          }
          .text1::before {
            content: "";
            position: absolute;
            left: 57px;
            top: -3px;
            width: 27px;
            height: 27px;
            .bg();
            background-image: url("../assets/becomevip/d.png");
          }
        }
        /*.text-wrap2 {
					margin-top: 14px;
					display: inline-block;
					text-align: left;
					color: #b58f71;
					font-size: 12px;

					.text1,
					.text2 {
						position: relative;
						padding-left: 34px;
						height: 31px;
						line-height: 31px;
						width: 100px;
					}
					.text2 {
						margin-top: 3px;
					}
					.text1::before,
					.text2::before {
						position: absolute;
						content: "";
						left: 0;
						top: 0;
						width: 31px;
						height: 31px;
						.bg();
					}
				}
				.text-wrap21 {
					.text1::before {
						background-image: url("../assets/becomevip/vip_item_01.svg");
					}
					.text2::before {
						background-image: url("../assets/becomevip/vip_item_04.svg");
					}
				}
				.text-wrap22 {
					margin-left: 15px;
					.text1::before {
						background-image: url("../assets/becomevip/vip_item_02.svg");
					}
					.text2::before {
						background-image: url("../assets/becomevip/vip_item_05.svg");
					}
				}
				.text-wrap23 {
					margin-left: 15px;

					.text1::before {
						background-image: url("../assets/becomevip/vip_item_03.svg");
					}
					.text2::before {
						background-image: url("../assets/becomevip/vip_item_06.svg");
					}
				}
				.text-wrap24 {
					margin-left: 15px;

					.text1::before {
						background-image: url("../assets/becomevip/f4.svg");
					}
					.text2::before {
						background-image: url("../assets/becomevip/f8.svg");
					}
				}*/
      }

      .vip-item-wrap {
        margin-top: 17px;
        text-align: center;
        .vip-item {
          display: inline-block;
          margin-left: 19px;
          margin-right: 19px;
          vertical-align: top;

          .icon1 {
            margin: 0 auto;
            width: 31px;
            height: 31px;
            .bg();
            background-image: url("../assets/userinfo/vip_item_icon_06.svg");
          }
          .icon2 {
            margin: 0 auto;
            width: 31px;
            height: 31px;
            .bg();
            background-size: 80% 80%;
            background-image: url("../assets/userinfo/vip_item_icon_07.svg");
          }
          .icon3 {
            margin: 0 auto;
            width: 31px;
            height: 31px;
            .bg();
            background-image: url("../assets/userinfo/vip11.png");
          }
          .icon4 {
            margin: 0 auto;
            width: 31px;
            height: 31px;
            .bg();
            background-image: url("../assets/userinfo/vip_item_icon_08.png");
          }
        }
      }
    }
  }
}
</style>
